import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import Box from '@mui/material/Box';
import { Container } from '@mui/material';

import { useDoctor } from 'src/hooks/use-doctor';

import Logo from 'src/components/logo';

import Nav from './nav';
import Main from './main';
import Header from './header';
import { ChatButton } from './common/chat';
import LanguagePopover from './common/language-popover';

// ----------------------------------------------------------------------

type Props = {
  children?: React.ReactNode;
};

export function DashboardLayout({ children }: Props) {
  const [openNav, setOpenNav] = useState(false);
  const { doctor } = useDoctor();
  const { pathname } = useLocation();

  const showChatPopup = !['/chat', '/demo'].includes(pathname);

  return (
    <>
      <Header onOpenNav={() => setOpenNav(true)} />

      <Box
        sx={{
          minHeight: 1,
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
        }}
      >
        <Nav openNav={openNav} setOpenNav={setOpenNav} />

        <Main>{children}</Main>

        {doctor?.doula && (
          <>
            {showChatPopup && <ChatButton />}
            {/* <EmailPopup emailExists={!doctor.email} id={doctor.id} /> */}
          </>
        )}
      </Box>
    </>
  );
}

export function NoNavLayout({ children }: Props) {
  return (
    <Container sx={{ p: 0 }}>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: { xs: 1, md: 2 },
          zIndex: 1000, // Ensure it stays on top of other content
        }}
      >
        <Logo
          sx={{
            ml: { xs: 1, md: 2 },
          }}
        />
        <Box
          sx={{
            mr: { xs: 1, md: 2 },
          }}
        >
          <LanguagePopover />
        </Box>
      </Box>

      <Container sx={{ height: '100%', p: 0 }}>{children}</Container>
    </Container>
  );
}
